export const convertToString = (value) => {
    if(value === undefined){
        return '';
    }
    if(value === 0){
        return '';
    }
    if (value % 1 === 0) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return value.toString().split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + value.toString().split('.')[1];
};

export const convertToApproximateString = (value) => {
    if(value === undefined){
        return '';
    }
    if(value === 0){
        return '';
    }
    if (value % 1 === 0) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return value.toString().split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + value.toString().split('.')[1].slice(0, 2);
};

export const modifyString = (value) => {
    if(value.length > 1 && value[0] === "0"){
        value = value.slice(1)
    }
    if(value.split('.').length == 2){
        const new_value = value.split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + value.split('.')[1];
        return new_value.replace(/[^0-9.,]/g, "");;
    }
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",").replace(/[^0-9.,]/g, "");;
};

export const convertToFloat = (value) => {
    if (typeof value === "string") {
        if(value === ''){
            return 0;
        }
        return parseFloat(value.split(',').join(''));
    }
};
